
import { Component, OnInit } from '@angular/core';
import { SubscriptionService } from "../../../shared/services/subscription.service";
import { AuthService } from "../../../shared/services/auth.service";
import { properties } from 'src/environments/properties';
import { ParamService } from 'src/app/shared/services/param.service';
import { ActivatedRoute } from '@angular/router';

declare let $: any;

@Component({
  selector: 'app-register-landing-page',
  templateUrl: './register-landing-page.component.html',
  styleUrls: ['./register-landing-page.component.scss'],
  providers: [SubscriptionService]
})
export class RegisterLandingPageComponent implements OnInit {

  currentEnvironment;
  banner;

  freshpassTilesComponent;
  freshpassBelowTilesComponent;
  frequentlyAskedQuestion;
  termsContent;
  showFreshpassTilesComponent = false;
  showFreshpassBelowTilesComponent = false;
  showFrequentlyAskedQuestion = false;
  showTermsContent = false;
  userInfo: any;
  isB2B: boolean;
  selectPlanStepRedirect: boolean;

  partnersData: any;
  enablePartners: boolean = properties.featureFlags.enablePartners;
  PARTNER_OFFER_TITLE: string = properties.partnersOffers.PARTNER_OFFER_TITLE;
  PARTNER_OFFER_SUBTITLE: string = properties.partnersOffers.PARTNER_OFFER_SUBTITLE;

  showPartnersComponent = false;
  enablePartnersOffersV2: boolean = false;
  configObj = {
    appName: 'freshpass',
    programType: 'partners'
  }

  constructor(public subscriptionService: SubscriptionService,
    public authService: AuthService,
    public route: ActivatedRoute,
    public paramService: ParamService) {
    this.banner = this.paramService.banner;
    this.isB2B = this.authService.checkB2B();
    const partnerPromotionBannerConfig = properties.featureFlags.partnerPromotionBannerConfig;
    this.enablePartnersOffersV2 = properties.featureFlags.enablePartnersOffersV2 && partnerPromotionBannerConfig[this.banner] === true;
    this.PARTNER_OFFER_TITLE = this.enablePartnersOffersV2 ? properties.partnersOffers.PARTNER_OFFER_TITLE_V2:properties.partnersOffers.PARTNER_OFFER_TITLE;
    this.PARTNER_OFFER_SUBTITLE = this.enablePartnersOffersV2 ? properties.partnersOffers.PARTNER_OFFER_SUBTITLE_V2:properties.partnersOffers.PARTNER_OFFER_SUBTITLE;
  }

  ngOnInit(): void {
    this.authService.getUserLogedInToken();
    this.authService.populateSessionData$.subscribe((userInfo) => {
      if (userInfo) {
        this.userInfo = userInfo;
        this.checkForceSignInRedirection(userInfo)
        if (this.enablePartners && !this.isB2B) {
          this.getPartnersData();
        }
      }
    });
    if (history?.state?.selectPlanStepRedirect) {
      this.selectPlanStepRedirect = history.state.selectPlanStepRedirect;
    }
    this.currentEnvironment = this.subscriptionService.getEnvironment();

    this.getFreshPassRegistrationLpMaster();
    this.getFreshPassRegistrationBelowTilesMaster();
    this.getFrequentlyAskedComponent();
    this.getTermsContent();
  }

  getFreshPassRegistrationBelowTilesMaster() {
    this.subscriptionService.getFreshPassRegistrationBelowTilesMaster(this.currentEnvironment).subscribe(data => {
      if (data) {
        this.freshpassBelowTilesComponent = data;
        this.showFreshpassBelowTilesComponent = true;
        setTimeout(() => {

          const linkElement = document.querySelector('a[data-qa="bunit-CTA"]');
          if (linkElement) {
            // Backup all existing child elements
            const childrenBackup = linkElement.children[0];

            // Clear the <a> tag (optional)
            linkElement.textContent = '';
            linkElement.removeAttribute("role");
            linkElement.removeAttribute("aria-label");

            // Create first span (screen reader only)
            const srSpan = document.createElement("span");
            srSpan.innerText = "Fresh Pass Start free trial";
            linkElement.appendChild(srSpan);
            linkElement.appendChild(childrenBackup);
          }

        }, 2000);
      }
    });
  }

  getFreshPassRegistrationLpMaster() {
    this.subscriptionService.getFreshPassRegistrationLpMaster(this.currentEnvironment).subscribe(data => {
      if (data) {
        this.freshpassTilesComponent = data;
        this.showFreshpassTilesComponent = true;
      }
    });
  }
  getFrequentlyAskedComponent() {
    this.subscriptionService.getFrequentlyAskedComponent(this.currentEnvironment).subscribe(data => {
      if (data) {
        this.frequentlyAskedQuestion = data;
        this.showFrequentlyAskedQuestion = true;
        setTimeout(() => {
          $('.accordion-container-title').remove();
          $('.accordion-header').toggleClass('inactive-header');
          $('.display-type').each(function () {
            let displayType = $(this).attr("data-display-type");
            if (displayType == 'expandFirst') {
              $(this).find('.accordion-header').first().toggleClass('active-header').toggleClass('inactive-header');
              $(this).find('.accordion-content').first().slideDown().toggleClass('open-content');
            } else if (displayType == 'expanded') {
              $(this).find('.accordion-header').toggleClass('active-header').toggleClass('inactive-header');
              $(this).find('.accordion-content').slideDown().toggleClass('open-content');
            }
          });

          // The Accordion Effect
          $(".accordion-header").each(function () {
            if ($(this).hasClass('active-header')) {
              $('.accordion-header').attr('aria-expanded', 'true');
            } else {
              $(this).attr('aria-expanded', 'false');
            }
          });

          $('.accordion-header').click(function () {
            if ($(this).is('.inactive-header')) {
              $(this).toggleClass('active-header').toggleClass('inactive-header');
              $(this).attr('aria-expanded', 'true');
              $(this).next().slideToggle().toggleClass('open-content');

            } else {
              $(this).toggleClass('active-header').toggleClass('inactive-header');
              $(this).attr('aria-expanded', 'false');
              $(this).next().slideToggle().toggleClass('open-content');
            }
          });

          $('.accordion-header').keypress(function (e) {
            let key = e.which;
            if (key == 13) {
              if ($(this).is('.inactive-header')) {
                $(this).toggleClass('active-header').toggleClass('inactive-header');
                $(this).attr('aria-expanded', 'true');
                $(this).next().slideToggle().toggleClass('open-content');

              } else {
                $(this).toggleClass('active-header').toggleClass('inactive-header');
                $(this).attr('aria-expanded', 'false');
                $(this).next().slideToggle().toggleClass('open-content');
              }
            }
          });
        }, 2000);
      }
    });
  }

  getTermsContent() {
    this.subscriptionService.getTermsComponent(this.currentEnvironment).subscribe(data => {
      if (data) {
        this.termsContent = data;
        this.showTermsContent = true;
        setTimeout(() => {
          // Add aria-hidden attribute to the ul element && Add sr-only span element to the link element

          const linkElement = document.querySelector('a[title="Our participating in-store Starbucks Cafés link"]');
          if (linkElement) {
            linkElement.removeAttribute("title");
            const ulElement = linkElement?.children[0];
            if (ulElement) {
              ulElement.setAttribute("aria-hidden", "true");
            }

            const spanElement = document.createElement("span");
            spanElement.classList.add("sr-only");
            spanElement.innerText = "Our participating in-store Starbucks Cafés";
            linkElement.appendChild(spanElement);
          }
        }, 2000);
      }
    });
  }

  getPartnersData() {
    let unSubscribedPageSource = 'paidmembership';
    this.subscriptionService.fetchPartnersCardData(this.userInfo, this.enablePartnersOffersV2, unSubscribedPageSource).subscribe({
      next: (offers) => {
        if (offers?.length > 0) {
          this.partnersData = {
            title: this.PARTNER_OFFER_TITLE,
            subTitle: this.PARTNER_OFFER_SUBTITLE,
            partnersInfo: offers,
          }
          this.showPartnersComponent = true;
        }
      },
      error: (error) => {
        console.error('Error fetching partners data', error);
      }
    });
  }

  checkForceSignInRedirection(userData) {
    const queryParams = this.route.snapshot.queryParams;
    if (!userData.isTokenValid && queryParams['forceSignin'] === 'true') {
      this.authService.redirectToSSO(userData);
    }
  }
}
